import { createModel } from "@rematch/core";

import type { RootModel } from '.';
import { PaginationFactory } from '../factory';
import { AlertTypes } from '../types';

export interface AlertStoreProps {
    pagination: PaginationFactory<AlertTypes.Model>,
    loading: {
        fetchMany: boolean,
        resolve: boolean,
    },
};

export const alertInitialState = {
    pagination: {} as PaginationFactory<AlertTypes.Model>,
    loading: {
        fetchMany: false,
        resolve: false,
    },
};

export const alert = createModel<RootModel>()({
    state: alertInitialState,
    reducers: {
        boot: (store) => {
            store = alertInitialState;
        },
        toggleLoading: (
            store, prop: keyof AlertStoreProps['loading'], v: boolean) => {
                store.loading[prop] = v;
            },
        updatePaginationItem: (store, alert: AlertTypes.Model) => {
            store.pagination.items = store.pagination.items?.map((p) => {
                if (p.id !== alert.id) {
                    return p;
                }

                return alert;
            });
        },
        setPagination: 
            (store, pagination: PaginationFactory<AlertTypes.Model>) => {
                store.pagination = pagination;
            },
        addPaginationItem: (store, item: AlertTypes.Model) => {
            store.pagination.items = [...store.pagination.items, item];
        },
    },
});
